import { render, staticRenderFns } from "./MfAvatar.vue?vue&type=template&id=5d36cd51&scoped=true&"
import script from "./MfAvatar.vue?vue&type=script&lang=js&"
export * from "./MfAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MfAvatar.vue?vue&type=style&index=0&id=5d36cd51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d36cd51",
  null
  
)

export default component.exports